import { _ as __assign, d as __rest, c as __read } from './chunks/tslib.es6-ebb56484.js';
import React__default, { useCallback, memo, useState } from 'react';
import { useIsMobile, useBoolean } from '@sravni/react-utils';
import { Typography } from '@sravni/react-design-system';
import { S as SpecialOffers } from './chunks/SpecialOffers-a6f847de.js';
import { w as withIdleWrapper } from './chunks/WithIdleWrapper-ebb607b6.js';
import { P as PopupForSpecialOffersWithAuthorization } from './chunks/PopupForSpecialOffersWithAuthorization-11394a2a.js';
import './chunks/UltimateSpecialOffers-41b10559.js';
import './chunks/index-9d6795ea.js';
import '@sravni/ugc/lib/specialOffers/helpers';
import '@sravni/ugc/lib/specialOffers/lists';
import './chunks/getTitle-6237901b.js';
import '@sravni/react-design-system/lib/Space';
import './chunks/isEqual-9167b1e9.js';
import './chunks/_baseIsEqual-16f30e0a.js';
import './chunks/isTypedArray-a816ffbf.js';
import 'crypto';
import './chunks/Preloader-30f97917.js';
import './chunks/ArrowRight-40285519.js';

var SpecialOffersContent = function (props) {
    var pushEvent = props.pushEvent, section = props.section, tabs = props.tabs, abName = props.abName, iframeSrc = props.iframeSrc, setContentLoaded = props.setContentLoaded, setActiveTab = props.setActiveTab;
    var isMobile = useIsMobile();
    var handleSetItemsCount = useCallback(function (count) {
        if (!count) {
            setContentLoaded(false);
            return;
        }
        if (count > 0) {
            setContentLoaded(true);
        }
    }, [setContentLoaded]);
    var pushEventWithSection = useCallback(function (event) {
        pushEvent(__assign(__assign({}, event), { eventAction: "".concat(event.eventAction, "|\u041F\u043E\u043F\u0430\u043F ").concat(section) }));
    }, [pushEvent, section]);
    return (React__default.createElement(SpecialOffers, { isWithButtons: true, pushEvent: pushEventWithSection, tabs: tabs, abName: abName, iframeSrc: iframeSrc, insidePopup: true, heading: React__default.createElement(Typography.Heading, { level: 3 }), headingType: isMobile ? 'horizontal' : 'popover', setItemsCount: handleSetItemsCount, onTabChange: setActiveTab }));
};

var SpecialOffersPopupIdle = withIdleWrapper(PopupForSpecialOffersWithAuthorization);
var IdleSpecialOffersPopup = memo(function (_a) {
    var isUserLogged = _a.isUserLogged, props = __rest(_a, ["isUserLogged"]);
    var _b = __read(useBoolean(), 2), wasShown = _b[0], setWasShown = _b[1];
    var _c = __read(useState(false), 2), isContentLoaded = _c[0], setContentLoaded = _c[1];
    var _d = __read(useState(), 2), activeTab = _d[0], setActiveTab = _d[1];
    if (isUserLogged)
        return null;
    return (React__default.createElement(SpecialOffersPopupIdle, { wasShown: wasShown, onClose: setWasShown.on, isContentLoaded: isContentLoaded, activeTab: activeTab, pushEvent: props.pushEvent },
        React__default.createElement(SpecialOffersContent, __assign({ setContentLoaded: setContentLoaded, setActiveTab: setActiveTab }, props))));
});

export { IdleSpecialOffersPopup };
//# sourceMappingURL=IdleSpecialOffersPopup.esm.js.map
